import { useMutation } from "urql";

import { UpdateCustomerDocument } from "../../../graphql/generated.ts";

export function useUpdateCustomer() {
  return useMutation(UpdateCustomerDocument);
}
